import { render, staticRenderFns } from "./SoftWare.vue?vue&type=template&id=ede9b3bc&scoped=true&lang=html&"
import script from "./SoftWare.vue?vue&type=script&lang=js&"
export * from "./SoftWare.vue?vue&type=script&lang=js&"
import style0 from "./SoftWare.vue?vue&type=style&index=0&id=ede9b3bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede9b3bc",
  null
  
)

export default component.exports